import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBallerinas = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1436_856)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.1768 8.21878C19.9905 7.98831 19.6642 7.93323 19.413 8.08558C14.5988 11.0043 12.0251 11.1996 10.7147 10.8489C9.84071 10.6153 9.56702 10.1395 9.56238 10.1317C9.424 9.85238 9.09735 9.72659 8.81091 9.843L7.84375 10.2338V9.22542C7.84375 8.89418 7.5778 8.62543 7.25 8.62543C6.9222 8.62543 6.65625 8.89418 6.65625 9.22542V10.193L5.65661 9.85628C5.34466 9.75003 5.00836 9.92112 4.90553 10.2356C4.80194 10.55 4.96971 10.8899 5.28088 10.9946L5.65188 11.1195L3.76287 11.8828C3.21885 12.1033 2.81586 12.5417 2.62481 13.0744C2.5516 13.1742 2.5 13.2914 2.5 13.425C2.5 13.458 2.51353 13.4864 2.5186 13.518C2.50855 13.6006 2.5 13.6838 2.5 13.7688C2.5 14.8891 3.40145 15.8 4.5097 15.8H20.2874C20.6121 15.8 20.8765 15.5367 20.8812 15.2086L20.9044 13.5594C21.6728 11.7946 21.3929 9.71252 20.1768 8.21878ZM8.83758 11.1246C9.11165 11.411 9.57475 11.7641 10.3092 11.9805C12.4519 12.6102 15.5621 11.7422 19.5537 9.39494C20.1846 10.4168 20.3152 11.6884 19.9095 12.825H4.62968L8.83758 11.1246ZM4.5097 14.6C4.1461 14.6 3.847 14.3564 3.73876 14.025H19.71L19.7021 14.6H4.5097Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1436_856",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 8,
			fill: "white",
			transform: "translate(2.5 8)"
		})
	}) })]
});
export default SvgBallerinas;
